import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/store/types';
import type { UserProfileRead } from 'src/common/external/bambi-api/bambiApi';

function pluckOrganizationById(profile: UserProfileRead, id: string) {
  return profile.memberships.find((membership) => {
    return membership.organization.id === id;
  })?.organization;
}

export function selectSendbirdAppId(state: RootState) {
  if (!state.auth.profile) return;

  if (state.auth.currentOrganizationId) {
    const organization = pluckOrganizationById(
      state.auth.profile,
      state.auth.currentOrganizationId
    );

    return organization?.chat_application_id;
  }
}
export function selectCurrentMembership(state: RootState) {
  if (!state.auth.profile) return;

  if (state.auth.currentOrganizationId) {
    return state.auth.profile.memberships.find((m) => {
      return m.organization.id === state.auth.currentOrganizationId;
    });
  }
}

export function selectCurrentOrganization(state: RootState) {
  if (!state.auth.profile) return;

  if (state.auth.currentOrganizationId) {
    return pluckOrganizationById(
      state.auth.profile,
      state.auth.currentOrganizationId
    );
  }

  if (state.auth.profile.memberships.length) {
    return state.auth.profile.memberships[0].organization;
  }

  throw new Error('AuthProvider: Profile has no memberships!');
}

export const selectCurrentOrganizationHeadquartersLocation = createSelector(
  selectCurrentOrganization,
  (organization) => {
    return organization?.settings.headquarters_location;
  }
);
